import { render, staticRenderFns } from "./knowledge_banner.vue?vue&type=template&id=f56f1612&scoped=true"
import script from "./knowledge_banner.vue?vue&type=script&lang=js"
export * from "./knowledge_banner.vue?vue&type=script&lang=js"
import style0 from "./knowledge_banner.vue?vue&type=style&index=0&id=f56f1612&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56f1612",
  null
  
)

export default component.exports